export interface IOrderViewPaymentInformation {
  selectedCardId?: string | null;
  paymentType?: PaymentType | null;
  paymentTypeName?: string | null;
}

export interface IPaymentTypeOption {
  label: string;
  value: string; // уникальное значение опции – id карты или способ оплаты
  paymentType: PaymentType;
  cardId?: string | null;
}

export interface IOrderCost {
  subTotalPrice?: null | number;
  discount?: null | number;
  bonusesUsed?: null | number;
  totalPrice?: null | number;
  paymentType?: null | PaymentType;
  cardNumber?: null | string;
  paymentSystem?: null | PaymentSystem;
  isPaid?: null | boolean;
}

export enum PaymentType {
  Unknown = 0,
  Cash = 1,
  Bonus = 2,
  Sms = 3,
  ContractorCardLinked = 4,
  InstallmentPlan = 5,
  Card = 6,
  SoftPos = 7,
  Link = 8,
  SettlementAccount = 9,
}

export enum PaymentSystem {
  AmericanExpress = 0,
  DinersClub = 1,
  Discover = 2,
  Jcb = 3,
  Maestro = 4,
  MasterCard = 5,
  Mir = 6,
  Pro100 = 7,
  UnionPay = 8,
  Visa = 9,
}
